// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-step .ant-steps-item-title {\n  color: green !important;\n  font-size: 14px !important;\n}\n.custom-step .ant-steps-icon {\n  color: green !important;\n}\n.custom-step-vertical .ant-steps-item-content {\n  width: 50% !important;\n}\n.custom-step-vertical .ant-steps-icon {\n  color: green !important;\n}\n", ""]);
// Exports
module.exports = exports;
